import type { TSlots } from 'shared/types/TDelivery';

import type { MeetingAvailable, MeetingsAvailable } from '../types';

export const transformSlotsToMeetings = (slots: TSlots['slots']): MeetingsAvailable => {
  const groupedByDate =
    slots?.reduce<Record<string, MeetingAvailable>>((acc, slot) => {
      const { date, timeFrom, timeTo, slotId } = slot;

      if (!acc[date]) {
        acc[date] = {
          date,
          intervals: [],
        };
      }

      acc[date].intervals.push({
        timeFrom,
        timeTo,
        slotId,
      });

      return acc;
    }, {}) || {};

  return Object.values(groupedByDate);
};
